// ─────────────────────────────────────────────────────────────────
//  BALI · All-Inclusive
// ─────────────────────────────────────────────────────────────────
export const BALI = {
  slug: "bali",
  price: 75000,
  currency: "INR",
  title: "Bali, All-Inclusive",
  priceLabel: "From ₹75,000 per person.",
  duration: "5N / 6D",
  durationLong: "5 Nights · 6 Days",
  seoTitle: "Bali All-Inclusive Package ₹75,000 from India | 5N/6D | Vacations Pro",
  seoDesc:
    "All-inclusive Bali holiday package starting at ₹75,000 per person — return flights, 4★ hotels, private transfers, daily breakfast and guided tours of Uluwatu, Ubud & Kintamani. Trusted by Indian families since 2004.",
  ogTitle: "Bali All-Inclusive Package ₹75,000 from India | Vacations Pro",
  ogDesc: "5N/6D Bali package with return flights, 4★ hotels, transfers and guided tours. From ₹75,000 per person. 4.8★ on Google.",
  eyebrow: "Summer 2026 · Early Bird",
  heroImg: "https://images.pexels.com/photos/2100804/pexels-photo-2100804.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Bali rice terraces at sunrise — Vacations Pro Bali Package",
  subline:
    "5 Nights · 6 Days with return flights, 4-star hotels, private transfers, daily breakfast and guided tours of Uluwatu, Ubud and Kintamani. Crafted by Vacations Pro — trusted by Indian families since 2004.",
  statStrip: [
    ["5N/6D", "Duration"],
    ["4★", "Hotels"],
    ["24×7", "Support"],
    ["Limited", "Seats"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",     body: "Ex-India airports" },
    { icon: "Hotel",      title: "5N/6D Hotel",        body: "4-star stays" },
    { icon: "Bus",        title: "Airport Transfers",  body: "Private AC cabs" },
    { icon: "Coffee",     title: "Daily Breakfast",    body: "At the hotel" },
    { icon: "Compass",    title: "Guided Tours",       body: "Kintamani · Uluwatu" },
    { icon: "FileCheck2", title: "Visa Assistance",    body: "On-arrival help" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "See a lower quote? We'll beat it by ₹2,000." },
    { title: "100% Safe & Secure",   body: "Government-registered IATA tour operator." },
    { title: "24×7 On-Trip Support", body: "WhatsApp a human, anywhere in Bali, anytime." },
    { title: "Locally-Owned",        body: "We partner directly with Bali hotels — no middlemen." },
  ],
  days: [
    { n: "01", title: "Arrival in Denpasar · Welcome to Bali", items: [
        "Airport pick-up with flower garland welcome",
        "Check-in at beachfront resort in Kuta/Seminyak",
        "Sunset stroll at Kuta Beach",
    ]},
    { n: "02", title: "South Bali · Uluwatu & Kecak Fire Dance", items: [
        "Visit Uluwatu Cliff Temple at sunset",
        "Traditional Kecak Fire Dance performance",
        "Seafood dinner at Jimbaran Bay (optional)",
    ]},
    { n: "03", title: "Ubud · Rice Terraces & Monkey Forest", items: [
        "Tegallalang Rice Terraces photo stop",
        "Sacred Monkey Forest Sanctuary",
        "Ubud Art Market & Palace",
    ]},
    { n: "04", title: "Kintamani Volcano & Coffee Plantations", items: [
        "Mount Batur viewpoint breakfast",
        "Luwak coffee tasting",
        "Tirta Empul holy water temple",
    ]},
    { n: "05", title: "Water Sports & Free Day at Nusa Dua", items: [
        "Jet ski, parasailing, banana boat (complimentary)",
        "Afternoon at leisure · spa optional",
        "Farewell Balinese dinner",
    ]},
    { n: "06", title: "Departure · Denpasar → India", items: [
        "Breakfast and check-out",
        "Airport drop-off transfer",
        "Return flight home with memories",
    ]},
  ],
  gallery: [
    { name: "Gates of Heaven", img: "https://images.pexels.com/photos/14475016/pexels-photo-14475016.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Nusa Penida",     img: "https://images.pexels.com/photos/1430677/pexels-photo-1430677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Tegallalang",     img: "https://images.pexels.com/photos/5151206/pexels-photo-5151206.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Seminyak Stays",  img: "https://images.pexels.com/photos/1802183/pexels-photo-1802183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Priya & Rohan",     tag: "Bengaluru · Honeymoon", img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "The itinerary was perfectly paced. Our villa in Ubud had a jungle view and everything — flights, transfers, tours — was handled flawlessly." },
    { name: "The Kapoor Family", tag: "Delhi · Group of 4",    img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "₹65,000 all-in felt too good to be true, but it wasn't. Hotels were 4-star, meals were excellent, and the water sports day was a hit with the kids." },
    { name: "Ananya S.",         tag: "Mumbai · Solo",         img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Safe, easy, and unforgettable. The local tour guide made Uluwatu and Kintamani come alive. Already planning a second trip through Vacations Pro." },
  ],
  faqs: [
    { q: "Is ₹75,000 the final price? Are there any hidden charges?",
      a: "₹75,000 per person (twin share) covers return economy flights, 5 nights of 4-star hotels, airport transfers, daily breakfast, and the listed guided tours. The only extras are personal expenses, optional dinners and Bali tourism tax (~₹1,200). No hidden charges, no surprises." },
    { q: "Which Indian cities do flights depart from?",
      a: "Direct departures from Delhi, Mumbai and Bengaluru, with 1-stop options from Amritsar, Chandigarh, Hyderabad and Kolkata. We always pick the routing with under-4-hour layovers." },
    { q: "What is the visa requirement for Indian citizens?",
      a: "Indian passport holders get visa on arrival in Bali (~USD 35, payable in INR equivalent). We provide complete documentation assistance and a step-by-step on-arrival guide before you fly." },
    { q: "Can I customise the itinerary or extend my stay?",
      a: "Absolutely. Add Nusa Penida, Gili Islands, or extend to 7-9 nights. Honeymoon couples often add a private villa night in Ubud. Tell our consultant on the call and we'll re-quote the same day." },
    { q: "Is this package good for honeymoon couples and families?",
      a: "Yes — both. Couples get a romantic upgrade option (candle-lit beach dinner + spa) for ₹6,000 add-on. Families get child-friendly hotels and the complimentary water sports day at Nusa Dua." },
    { q: "What is the cancellation and refund policy?",
      a: "Free cancellation up to 30 days before departure (full refund minus visa fees). 50% refund up to 15 days before. Inside 15 days, only government taxes are refundable. Travel insurance recommended — we can arrange it." },
  ],
  finalCta: { badge: "Only 12 seats left this month", headline: "Your Bali escape starts at ₹75,000." },
  departureCity: "Ludhiana / Delhi / Mumbai / Bengaluru",
  arrivalCity: "Denpasar, Bali, Indonesia",
  waSave: "₹15,000",
};

// ─────────────────────────────────────────────────────────────────
//  MALDIVES · Water Villa Luxury
// ─────────────────────────────────────────────────────────────────
export const MALDIVES = {
  slug: "maldives",
  price: 145000,
  currency: "INR",
  title: "Maldives Water Villa Luxury",
  priceLabel: "From ₹1,45,000 per person.",
  duration: "4N / 5D",
  durationLong: "4 Nights · 5 Days",
  seoTitle: "Maldives Water Villa Luxury Honeymoon ₹1,45,000 from India | Vacations Pro",
  seoDesc:
    "All-inclusive Maldives water villa luxury honeymoon from ₹1,45,000 per person — return flights, overwater villa, seaplane transfers and candle-lit dinner. Maldives luxury honeymoon agent trusted since 2004.",
  ogTitle: "Maldives Water Villa Honeymoon ₹1,45,000 from India | Vacations Pro",
  ogDesc: "4N/5D Maldives water villa package with return flights, seaplane transfers and half-board. From ₹1,45,000 per person.",
  eyebrow: "Honeymoon 2026 · Private Villas",
  heroImg: "https://images.pexels.com/photos/1287460/pexels-photo-1287460.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Maldives overwater villa sunrise — Vacations Pro luxury honeymoon",
  subline:
    "4 Nights · 5 Days of pure Indian-Ocean luxury — return flights, private overwater villa, seaplane transfers, half-board meals and a candle-lit sandbank dinner. Crafted by Vacations Pro — Maldives luxury honeymoon agents since 2004.",
  statStrip: [
    ["4N/5D", "Duration"],
    ["5★", "Water Villa"],
    ["Half Board", "Meals"],
    ["Seaplane", "Transfers"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",    body: "Delhi / Mumbai / BLR" },
    { icon: "Hotel",      title: "Overwater Villa",   body: "5★ private deck" },
    { icon: "Bus",        title: "Seaplane Transfers", body: "MLE → resort" },
    { icon: "Coffee",     title: "Half-Board Meals",  body: "Breakfast + dinner" },
    { icon: "Compass",    title: "Honeymoon Extras",  body: "Sandbank dinner + spa" },
    { icon: "FileCheck2", title: "Free Visa on Arrival", body: "30-day Indian passport" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "Match any comparable luxury Maldives quote — or we pay the difference." },
    { title: "Verified Resorts",     body: "Only 5★ properties we've personally stayed at — no mystery hotels." },
    { title: "24×7 On-Trip Support", body: "Dedicated WhatsApp hotline for overwater-villa guests." },
    { title: "20 Years in India",    body: "Trusted by 1,000+ Indian honeymoon couples since 2004." },
  ],
  days: [
    { n: "01", title: "Arrival · Seaplane to Your Water Villa", items: [
        "Direct flight Delhi/Mumbai/BLR → Malé",
        "Scenic seaplane transfer to the resort",
        "Check-in to your private overwater villa · chilled champagne on arrival",
    ]},
    { n: "02", title: "House Reef Snorkelling & Sunset Dinner", items: [
        "Morning snorkel on the house reef — vibrant coral & turtles",
        "Afternoon at leisure · infinity pool",
        "Romantic beach dinner under the stars",
    ]},
    { n: "03", title: "Sandbank Picnic & Couples Spa", items: [
        "Private sandbank excursion with a chilled lunch hamper",
        "Signature couples spa treatment (60 min)",
        "Dinner at an over-the-water specialty restaurant",
    ]},
    { n: "04", title: "Dolphin Cruise & Free Day", items: [
        "Dawn dolphin cruise with sparkling wine",
        "Afternoon at leisure · optional scuba or manta-ray snorkelling",
        "Farewell Maldivian dinner on the beach",
    ]},
    { n: "05", title: "Departure · Back to India", items: [
        "Leisurely breakfast on your villa deck",
        "Seaplane transfer back to Malé (MLE)",
        "Return flight home with unforgettable memories",
    ]},
  ],
  gallery: [
    { name: "Overwater Villa", img: "https://images.pexels.com/photos/1287460/pexels-photo-1287460.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "House Reef",      img: "https://images.pexels.com/photos/1450360/pexels-photo-1450360.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Sandbank",        img: "https://images.pexels.com/photos/3601425/pexels-photo-3601425.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Sunset Dhoni",    img: "https://images.pexels.com/photos/390049/pexels-photo-390049.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Aarav & Meera",   tag: "Pune · Honeymoon",   img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Our overwater villa was beyond expectations — the sandbank dinner was the single best night of our lives. Vacations Pro handled every detail." },
    { name: "The Malhotras",   tag: "Delhi · Anniversary", img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "25th anniversary trip, done right. Seaplane transfers were on time and the spa at the villa was world class." },
    { name: "Rohan & Ishita",  tag: "Ludhiana · Couple",   img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "₹1.45L all-in was the best rate we found across four agents. Zero surprises — exactly what the PDF showed." },
  ],
  faqs: [
    { q: "Is ₹1,45,000 the final price? What's included?",
      a: "Yes — ₹1,45,000 per person (twin share) includes return economy flights, 4 nights in a 5-star overwater villa, return seaplane transfers, daily breakfast + dinner, and honeymoon extras (sandbank dinner + couples spa). Only Maldivian Green Tax (~₹3,000) and personal spa/dive add-ons are extra." },
    { q: "Are Indian passport holders visa-free in the Maldives?",
      a: "Yes. Indian passport holders receive a free 30-day visa on arrival. We pre-fill the Traveller Declaration form for you before departure." },
    { q: "Which resorts do you partner with?",
      a: "We work with 12+ vetted 5★ properties across North & South Malé, Baa, Ari and Dhaalu Atolls. Your consultant picks 3 options matching your honeymoon vibe — beach-party, serene-secluded or family-friendly." },
    { q: "Can you arrange direct flights from Amritsar or Ludhiana?",
      a: "Yes — Amritsar → Delhi → Malé with under-4-hour layovers. Ludhiana guests we route via Chandigarh or Delhi. All routing is confirmed in your custom PDF before booking." },
    { q: "When is the best time to go?",
      a: "Peak season is November to April (dry, sunny). Shoulder season May/October offers 20-30% savings with occasional showers. Our consultant aligns the best resort + best price window for your dates." },
    { q: "What if weather disrupts the seaplane?",
      a: "All our partner resorts offer complimentary airport rooms + rescheduled seaplane. We also book refundable fares and recommend travel insurance (can be arranged at ₹1,500)." },
  ],
  finalCta: { badge: "Only 8 water villas left for 2026", headline: "Your Maldives honeymoon starts at ₹1,45,000." },
  departureCity: "Delhi / Mumbai / Bengaluru",
  arrivalCity: "Malé, Maldives",
  waSave: "₹25,000",
};

// ─────────────────────────────────────────────────────────────────
//  LEH LADAKH · Luxury 4x4 Tour
// ─────────────────────────────────────────────────────────────────
export const LEH = {
  slug: "leh-ladakh",
  price: 45000,
  currency: "INR",
  title: "Leh Ladakh Luxury 4×4",
  priceLabel: "From ₹45,000 per person.",
  duration: "6N / 7D",
  durationLong: "6 Nights · 7 Days",
  seoTitle: "Leh Ladakh Luxury 4x4 Tour 2026 ₹45,000 from Ludhiana | Vacations Pro",
  seoDesc:
    "Leh Ladakh luxury 4×4 tour 2026 from Ludhiana — Pangong, Nubra, Khardung-La, guided premium SUV, oxygen-equipped hotels. Ladakh specialists since 2004.",
  ogTitle: "Leh Ladakh Luxury 4×4 Tour 2026 ₹45,000 | Vacations Pro",
  ogDesc: "6N/7D Leh Ladakh 4×4 tour with premium SUV, Pangong & Nubra, from ₹45,000.",
  eyebrow: "Summer 2026 · Ladakh Specialists",
  heroImg: "https://images.pexels.com/photos/46253/mt-fuji-sea-of-clouds-sunrise-46253.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Leh Ladakh Pangong Lake at sunrise — Vacations Pro luxury 4x4 tour",
  subline:
    "6 Nights · 7 Days across Leh, Pangong, Nubra and Khardung-La — premium Toyota Fortuner / Innova, oxygen-equipped hotels, permits handled. The best Leh Ladakh specialists from Punjab since 2004.",
  statStrip: [
    ["6N/7D", "Duration"],
    ["4x4 SUV", "Private"],
    ["3★+", "Hotels"],
    ["All Permits", "Included"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Flights to Leh",      body: "Delhi → IXL · scenic" },
    { icon: "Hotel",      title: "Oxygen-Ready Hotels", body: "3★+ in Leh/Nubra" },
    { icon: "Bus",        title: "Premium 4×4 SUV",     body: "Fortuner / Innova" },
    { icon: "Coffee",     title: "Daily Breakfast+Dinner", body: "At every hotel" },
    { icon: "Compass",    title: "Permits & Guide",     body: "Inner line + driver" },
    { icon: "FileCheck2", title: "Monastery Visits",    body: "Thiksey, Hemis, Diskit" },
  ],
  whyUs: [
    { title: "Altitude-Safe Itinerary", body: "Day 1 acclimatisation · oxygen in every room · on-call doctor line." },
    { title: "Premium 4×4 Only",        body: "No shared cabs — every group gets a dedicated Fortuner or Innova Crysta." },
    { title: "Local Ladakhi Guides",    body: "Born-and-raised Leh guides who know every high-pass shortcut." },
    { title: "Ludhiana HQ",             body: "We've sent 500+ Punjab families to Ladakh since 2004." },
  ],
  days: [
    { n: "01", title: "Arrival Leh · Acclimatisation Day", items: [
        "Morning flight Delhi → Leh (IXL)",
        "Hotel check-in · rest at altitude",
        "Light evening walk to Leh Market",
    ]},
    { n: "02", title: "Leh Sightseeing · Monasteries", items: [
        "Shanti Stupa at sunrise",
        "Thiksey + Hemis monasteries",
        "Shey Palace & Stok Museum",
    ]},
    { n: "03", title: "Leh → Nubra via Khardung-La", items: [
        "Khardung-La pass (18,380 ft)",
        "Diskit Monastery & giant Buddha",
        "Hunder sand dunes · double-humped camels",
    ]},
    { n: "04", title: "Nubra → Pangong via Shyok", items: [
        "Shyok river route (scenic)",
        "Arrive Pangong by late afternoon",
        "Sunset at the lake · overnight in luxury camp",
    ]},
    { n: "05", title: "Pangong → Leh via Chang-La", items: [
        "Sunrise at Pangong Lake",
        "Chang-La pass (17,586 ft)",
        "Evening at leisure in Leh",
    ]},
    { n: "06", title: "Sham Valley · Magnetic Hill", items: [
        "Pathar Sahib Gurudwara",
        "Magnetic Hill & Sangam viewpoint",
        "Alchi Monastery (1000-year-old)",
    ]},
    { n: "07", title: "Departure · Leh → Home", items: [
        "Early breakfast",
        "Transfer to Leh airport",
        "Return flight Delhi / onward",
    ]},
  ],
  gallery: [
    { name: "Pangong Tso",      img: "https://images.pexels.com/photos/3673905/pexels-photo-3673905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Nubra Dunes",      img: "https://images.pexels.com/photos/2474689/pexels-photo-2474689.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Thiksey Monastery",img: "https://images.pexels.com/photos/5207262/pexels-photo-5207262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Khardung-La",      img: "https://images.pexels.com/photos/3889929/pexels-photo-3889929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Harpreet Singh",   tag: "Ludhiana · Group of 6", img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Our Fortuner was pristine, the driver-guide was incredible. Oxygen in the rooms was a lifesaver on night 1. Best Leh trip I've ever done." },
    { name: "Dr. Arun Verma",   tag: "Chandigarh · Family",   img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "The acclimatisation day on arrival is exactly why we chose Vacations Pro. No altitude issues for any of us. Smooth permits, great hotels." },
    { name: "Simran Kaur",      tag: "Amritsar · Couple",     img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Pangong luxury tent camp was magical. The team handled permits, flights, hotels — we just had to show up and enjoy." },
  ],
  faqs: [
    { q: "What's the best time to visit Leh Ladakh?",
      a: "May to mid-September is peak (all passes open). For fewer crowds + snow-capped passes, we also run tours in late April and early October. Pangong is accessible year-round but most luxury camps shut between Nov-Apr." },
    { q: "Is altitude sickness a concern?",
      a: "Mild symptoms are common at Leh (11,500 ft). Our Day-1 rest protocol + oxygen-equipped rooms + pre-trip acclimatisation guide keeps 98% of our guests symptom-free. We also carry portable oxygen in every vehicle." },
    { q: "What type of vehicle will we travel in?",
      a: "Premium Toyota Fortuner or Innova Crysta — always private, never shared. For groups of 6+, we split into 2 vehicles for comfort." },
    { q: "Are flights included in the ₹45,000 price?",
      a: "Yes — return Delhi ↔ Leh economy flights are included. Ludhiana/Amritsar/Chandigarh guests we either route via Delhi (rail+flight) or offer a 10% discount if you book your own feeder." },
    { q: "Do you handle inner-line permits?",
      a: "Yes — we pre-arrange inner-line permits for Nubra, Pangong, Khardung-La, Tso Moriri before your arrival. Zero paperwork at your end." },
    { q: "Is this itinerary good for families with kids?",
      a: "Kids 10+ handle Leh well. For younger children, we customise a 4-night Leh + Nubra-only route (skipping Pangong's higher altitude). Tell us on the call." },
  ],
  finalCta: { badge: "Only 4 SUVs available for May departure", headline: "Your Ladakh adventure starts at ₹45,000." },
  departureCity: "Ludhiana / Delhi",
  arrivalCity: "Leh, Ladakh",
  waSave: "₹8,000",
};

// ─────────────────────────────────────────────────────────────────
//  SRI LANKA · Heritage + Coast Escape
// ─────────────────────────────────────────────────────────────────
export const SRI_LANKA = {
  slug: "sri-lanka",
  price: 35000,
  currency: "INR",
  title: "Sri Lanka Heritage & Coast",
  priceLabel: "From ₹35,000 per person.",
  duration: "5N / 6D",
  durationLong: "5 Nights · 6 Days",
  seoTitle: "Sri Lanka Tour Package ₹35,000 from India | 5N/6D | Vacations Pro",
  seoDesc:
    "All-inclusive Sri Lanka heritage & coast tour from ₹35,000 per person — return flights, 4★ hotels, private AC car, ETA visa help, daily breakfast. Sigiriya, Kandy, Ella train, Mirissa whales. Trusted since 2004.",
  ogTitle: "Sri Lanka Heritage Package ₹35,000 from India | Vacations Pro",
  ogDesc: "5N/6D Sri Lanka package: Sigiriya, Kandy, Ella train, Mirissa. From ₹35,000 per person. 4.8★ on Google.",
  eyebrow: "Winter 2026 · Early Bird",
  heroImg: "https://images.pexels.com/photos/5759193/pexels-photo-5759193.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Sigiriya Lion Rock Sri Lanka — Vacations Pro heritage tour package",
  subline:
    "5 Nights · 6 Days across Sigiriya, Kandy, Nuwara Eliya and Mirissa — return flights, 4-star hotels, private AC car with English-speaking driver, daily breakfast and the world's most scenic train ride through the tea country. Crafted by Vacations Pro since 2004.",
  statStrip: [
    ["5N/6D", "Duration"],
    ["4★", "Hotels"],
    ["Private Car", "With Driver"],
    ["ETA Help", "Included"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",      body: "Delhi / Mumbai / BLR" },
    { icon: "Hotel",      title: "5N Hotel Stay",       body: "4-star properties" },
    { icon: "Bus",        title: "Private AC Car",      body: "Driver-guide included" },
    { icon: "Coffee",     title: "Daily Breakfast",     body: "At the hotel" },
    { icon: "Compass",    title: "Guided Tours",        body: "Sigiriya · Kandy · Ella" },
    { icon: "FileCheck2", title: "ETA Visa Assistance", body: "We file it for you" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "See a lower quote for the same itinerary? We'll beat it by ₹1,500." },
    { title: "Government Registered", body: "IATA + Sri Lanka Tourism Board licensed partner network." },
    { title: "24×7 On-Trip Support", body: "WhatsApp our Colombo team instantly from anywhere on the island." },
    { title: "20 Years in India",    body: "Over 600 Indian families sent to Sri Lanka since 2004." },
  ],
  days: [
    { n: "01", title: "Arrival Colombo · Drive to Sigiriya", items: [
        "Airport pick-up at CMB + garland welcome",
        "Scenic drive to Sigiriya (4 hours)",
        "Evening check-in · Sri Lankan welcome dinner",
    ]},
    { n: "02", title: "Sigiriya Lion Rock & Dambulla Caves", items: [
        "Sunrise climb of Sigiriya Rock Fortress (UNESCO)",
        "Dambulla Cave Temple · ancient Buddhist frescoes",
        "Village tuk-tuk ride + bullock cart experience",
    ]},
    { n: "03", title: "Kandy · Temple of the Tooth", items: [
        "Drive to Kandy via spice garden (2.5 hrs)",
        "Evening ceremony at Temple of the Tooth",
        "Kandyan cultural dance performance",
    ]},
    { n: "04", title: "Kandy → Ella Scenic Train", items: [
        "World's most scenic train — Kandy to Ella (7 hrs)",
        "Tea plantations, viaducts and cloud forests",
        "Check-in at Ella · sunset at Little Adam's Peak",
    ]},
    { n: "05", title: "Ella → Mirissa Beach", items: [
        "Nine Arch Bridge photo stop",
        "Drive to south coast Mirissa (3 hrs)",
        "Coconut Tree Hill sunset · beach-town dinner",
    ]},
    { n: "06", title: "Mirissa Whales & Departure", items: [
        "Dawn blue-whale safari (Nov-Apr sightings)",
        "Drive back to Colombo airport (3 hrs)",
        "Return flight home with memories",
    ]},
  ],
  gallery: [
    { name: "Sigiriya Rock",   img: "https://images.pexels.com/photos/5759193/pexels-photo-5759193.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Ella Train",      img: "https://images.pexels.com/photos/3214995/pexels-photo-3214995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Tea Country",     img: "https://images.pexels.com/photos/1638991/pexels-photo-1638991.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Mirissa Beach",   img: "https://images.pexels.com/photos/1320686/pexels-photo-1320686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Kavita & Ajay",    tag: "Bengaluru · Family of 4", img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Our kids loved the Sigiriya climb and the Ella train was unreal. The driver-guide became like family in 6 days. Incredible value for ₹35K." },
    { name: "The Mehta Family", tag: "Mumbai · Group of 6",     img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "We booked 3 weeks before departure and they still got us 4-star hotels at a great price. Mirissa whale sighting was the trip's highlight." },
    { name: "Reshma K.",        tag: "Chennai · Couple",        img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Perfect mix of heritage, hills and beach. ETA visa was filed by them before we even asked. 10/10 would rebook." },
  ],
  faqs: [
    { q: "Is ₹35,000 the final price? What's included?",
      a: "Yes — ₹35,000 per person (twin share) covers return economy flights, 5 nights of 4-star hotels, private AC car with driver-guide, daily breakfast, and all entry tickets (Sigiriya, Dambulla, Temple of the Tooth). Only ETA visa (~USD 50 / ₹4,200) and personal dinners are extra." },
    { q: "What is the visa requirement for Indian citizens?",
      a: "Sri Lanka ETA (Electronic Travel Authorisation) is required — approx USD 50 for 30 days. We file it for you in 24 hours once we receive your passport scan." },
    { q: "Is the Ella train safe and comfortable?",
      a: "Yes — we book 1st-class reserved observation seats (not the crowded 2nd class). 7 hours of scenic travel with AC and meals available onboard." },
    { q: "Which months are best for Sri Lanka?",
      a: "December to March is the driest window for the west + south coasts (Mirissa, Galle). April to September is best for the east coast (Trincomalee, Arugam Bay)." },
    { q: "Can I see whales at Mirissa?",
      a: "Yes — November to April is peak blue-whale & sperm-whale season. We partner with responsible operators (no harassment of marine life, 2-hour boat rides)." },
    { q: "Can I extend to Galle or Yala Safari?",
      a: "Absolutely. Add Galle Fort (1 night, +₹4,500) or Yala leopard safari (2 days, +₹12,000). Tell our consultant on the call." },
  ],
  finalCta: { badge: "Only 18 seats left this month", headline: "Your Sri Lanka escape starts at ₹35,000." },
  departureCity: "Delhi / Mumbai / Bengaluru / Chennai",
  arrivalCity: "Colombo (CMB), Sri Lanka",
  waSave: "₹8,000",
};

// ─────────────────────────────────────────────────────────────────
//  DUBAI · Skyline & Desert
// ─────────────────────────────────────────────────────────────────
export const DUBAI = {
  slug: "dubai",
  price: 48000,
  currency: "INR",
  title: "Dubai Skyline & Desert",
  priceLabel: "From ₹48,000 per person.",
  duration: "4N / 5D",
  durationLong: "4 Nights · 5 Days",
  seoTitle: "Dubai Tour Package ₹48,000 from India | 4N/5D | Burj Khalifa + Desert Safari | Vacations Pro",
  seoDesc:
    "All-inclusive Dubai tour from ₹48,000 per person — return flights, 4★ hotels, Burj Khalifa At The Top, Desert Safari with BBQ, Marina Dhow Cruise and Global Village. Dubai family vacation specialists since 2004.",
  ogTitle: "Dubai Family Package ₹48,000 from India | Vacations Pro",
  ogDesc: "4N/5D Dubai package with return flights, 4★ hotels, Burj Khalifa + Desert Safari + Marina Cruise. From ₹48,000 pp.",
  eyebrow: "Winter 2026 · Best of Dubai",
  heroImg: "https://images.pexels.com/photos/823696/pexels-photo-823696.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Dubai Burj Khalifa skyline at dusk — Vacations Pro family tour package",
  subline:
    "4 Nights · 5 Days of Dubai magic — return flights, 4-star hotels near the Metro, Burj Khalifa 124+148 floor tickets, Red Dunes desert safari with BBQ dinner, Marina Dhow cruise and shopping at Global Village. Trusted by Indian families since 2004.",
  statStrip: [
    ["4N/5D", "Duration"],
    ["4★", "Hotels"],
    ["Burj Khalifa", "124+148 F"],
    ["Desert Safari", "BBQ Dinner"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",       body: "Delhi / Mumbai / BLR" },
    { icon: "Hotel",      title: "4N Hotel Stay",        body: "4★ near Metro" },
    { icon: "Bus",        title: "Airport Transfers",    body: "Private AC SUV" },
    { icon: "Coffee",     title: "Daily Breakfast",      body: "At the hotel" },
    { icon: "Compass",    title: "Burj + Desert + Dhow", body: "3 signature tours" },
    { icon: "FileCheck2", title: "UAE e-Visa Help",      body: "48-hour processing" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "See a lower quote with same inclusions? We'll beat it by ₹2,000." },
    { title: "DTCM Licensed Partner", body: "Dubai Tourism Board authorised operators only — no grey-market tickets." },
    { title: "24×7 On-Trip Support",  body: "Our Dubai team is 1 WhatsApp away — city knowledge + Hindi/Punjabi/English." },
    { title: "Indian Food Options",   body: "Jain/vegetarian meal hotels curated — no restaurant hunting required." },
  ],
  days: [
    { n: "01", title: "Arrival Dubai · Marina Dhow Cruise", items: [
        "Airport pick-up and hotel check-in",
        "Evening Marina Dhow Cruise with buffet dinner",
        "Skyline views + live Tanoura dance",
    ]},
    { n: "02", title: "Burj Khalifa · Dubai Mall · Fountains", items: [
        "Burj Khalifa At The Top — 124+148 floor combo",
        "Dubai Mall + Dubai Aquarium walkthrough",
        "Dubai Fountain show at sunset",
    ]},
    { n: "03", title: "City Tour · Gold Souk · Miracle Garden", items: [
        "Dubai city tour — Burj Al Arab, Jumeirah Mosque, Palm",
        "Old Dubai Creek abra ride · Spice + Gold souks",
        "Miracle Garden + Global Village shopping (seasonal)",
    ]},
    { n: "04", title: "Red Dunes Desert Safari · BBQ Dinner", items: [
        "Morning at leisure · pool time",
        "Afternoon 4×4 dune bashing on the Red Dunes",
        "Bedouin camp: camel ride, henna, falcon, BBQ dinner + dances",
    ]},
    { n: "05", title: "Free Day · Departure", items: [
        "Breakfast + shopping at Deira / Mall of Emirates (optional)",
        "Private transfer to DXB airport",
        "Return flight home",
    ]},
  ],
  gallery: [
    { name: "Burj Khalifa",     img: "https://images.pexels.com/photos/823696/pexels-photo-823696.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Desert Safari",    img: "https://images.pexels.com/photos/3889929/pexels-photo-3889929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Marina Skyline",   img: "https://images.pexels.com/photos/1470502/pexels-photo-1470502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Old Dubai Souk",   img: "https://images.pexels.com/photos/1470405/pexels-photo-1470405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "The Gupta Family", tag: "Delhi · Group of 5",   img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Kids loved the desert safari, parents loved the Burj Khalifa at sunset. 4-star hotel was walking distance from the Metro. Flawless execution." },
    { name: "Navdeep Singh",    tag: "Ludhiana · Couple",    img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "₹48K felt unbeatable. We splurged on a Global Village dinner upgrade — that was the only extra. Everything else was already covered." },
    { name: "Meera Shah",       tag: "Ahmedabad · Family",   img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Jain meal hotel was a blessing. Tour guides in Hindi + English made it smooth for my parents. Highly recommend for Indian families." },
  ],
  faqs: [
    { q: "Is ₹48,000 the final price? Any hidden charges?",
      a: "₹48,000 per person (twin share) includes return flights, 4 nights of 4-star hotels, daily breakfast, all 3 tours (Burj, Desert, Dhow), and private airport transfers. UAE e-visa (~₹8,000), tourism dirham fee (~₹400) and personal meals are the only extras. Upfront. Transparent." },
    { q: "What is the visa requirement for Indian passport holders?",
      a: "UAE e-Visa is required — 48-hour processing, we file it for you. Indians with US/UK/Schengen visas get on-arrival instead (even quicker). Documents needed: passport scan + 2 photos." },
    { q: "Which Indian cities have direct flights to Dubai?",
      a: "Direct flights from Delhi, Mumbai, Bengaluru, Chennai, Hyderabad, Kolkata, Ahmedabad, Cochin and Amritsar. We always pick the shortest layover (under 4 hours)." },
    { q: "Is Dubai safe for solo female travellers / families?",
      a: "One of the safest cities in the world. The UAE has zero tolerance for harassment. Our Indian family groups report 100% comfort — we also have a women-led ground team for additional support." },
    { q: "Is there halal / Jain / vegetarian food?",
      a: "Yes — we book hotels with Indian restaurants + curate Jain meal pointers. Bur Dubai / Deira areas have hundreds of Indian vegetarian outlets within 5 minutes." },
    { q: "Best time to visit Dubai?",
      a: "November to March is peak (20-28°C, perfect weather). Avoid June-August (40°C+). Our ₹48K base price is for Nov-Mar peak departures." },
  ],
  finalCta: { badge: "Only 22 seats left for Dec", headline: "Your Dubai escape starts at ₹48,000." },
  departureCity: "Delhi / Mumbai / Bengaluru / Amritsar / Chennai",
  arrivalCity: "Dubai (DXB), UAE",
  waSave: "₹12,000",
};

// ─────────────────────────────────────────────────────────────────
//  THAILAND · Bangkok + Phuket Family Escape
// ─────────────────────────────────────────────────────────────────
export const THAILAND = {
  slug: "thailand",
  price: 42000,
  currency: "INR",
  title: "Thailand Bangkok & Phuket",
  priceLabel: "From ₹42,000 per person.",
  duration: "5N / 6D",
  durationLong: "5 Nights · 6 Days",
  seoTitle: "Thailand Package ₹42,000 from India | 5N/6D Bangkok + Phuket | Vacations Pro",
  seoDesc:
    "All-inclusive Thailand tour from ₹42,000 per person — Bangkok + Phuket, return flights, 4★ hotels, Phi Phi island hop, Safari World and Grand Palace. Thailand family vacation specialists since 2004.",
  ogTitle: "Thailand Bangkok + Phuket ₹42,000 from India | Vacations Pro",
  ogDesc: "5N/6D Thailand package: Bangkok city tour, Phuket beaches, Phi Phi island hop. From ₹42,000 pp.",
  eyebrow: "Winter 2026 · Family Favourite",
  heroImg: "https://images.pexels.com/photos/1007657/pexels-photo-1007657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Phuket Phi Phi Island longtail boats — Vacations Pro Thailand family tour",
  subline:
    "5 Nights · 6 Days across Bangkok and Phuket — return flights, 4-star hotels, Safari World, Grand Palace, Phi Phi Island day cruise and Phuket Fantasea show. Free visa on arrival for Indians. Crafted by Vacations Pro since 2004.",
  statStrip: [
    ["5N/6D", "Duration"],
    ["2 Cities", "Bangkok + Phuket"],
    ["4★", "Hotels"],
    ["Free VOA", "Indian Passport"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",      body: "Del/Mum/BLR → BKK + internal" },
    { icon: "Hotel",      title: "5N Hotel Stay",       body: "4★ · 2N Bkk + 3N Phuket" },
    { icon: "Bus",        title: "Airport Transfers",   body: "Private AC SUV" },
    { icon: "Coffee",     title: "Daily Breakfast",     body: "At both hotels" },
    { icon: "Compass",    title: "Guided Tours",        body: "Safari World · Phi Phi · Fantasea" },
    { icon: "FileCheck2", title: "Free VOA Assistance", body: "30-day Indian passport" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "Same itinerary quoted cheaper? We'll beat it by ₹1,500." },
    { title: "TAT Licensed Partner", body: "Tourism Authority of Thailand authorised — zero grey-market risks." },
    { title: "24×7 On-Trip Support", body: "Bangkok + Phuket ground teams on WhatsApp — Hindi/English/Punjabi." },
    { title: "Indian Meal Options",  body: "Bangkok + Phuket hotels chosen with Indian veg/Jain dining nearby." },
  ],
  days: [
    { n: "01", title: "Arrival Bangkok · Free Evening", items: [
        "Airport pick-up at BKK + hotel check-in",
        "Evening walk through Siam or Sukhumvit",
        "Optional Thai massage + street food dinner",
    ]},
    { n: "02", title: "Safari World + Marine Park", items: [
        "Full-day Safari World — drive-through zoo + dolphin/orca shows",
        "Marine Park bird, stunt and animal shows",
        "Buffet lunch + return to hotel",
    ]},
    { n: "03", title: "Grand Palace + Flight to Phuket", items: [
        "Grand Palace & Temple of Emerald Buddha morning tour",
        "Afternoon flight Bangkok → Phuket (1.5 hrs)",
        "Check-in Patong · evening at Bangla Walking Street",
    ]},
    { n: "04", title: "Phi Phi Islands Full-Day Cruise", items: [
        "Speedboat to Phi Phi Don + Phi Phi Leh",
        "Maya Bay, Monkey Beach, Bamboo Island snorkel",
        "Thai buffet lunch at Phi Phi Don",
    ]},
    { n: "05", title: "Phuket City + Fantasea Show", items: [
        "Morning at leisure · optional ATV or spa",
        "Phuket city half-day: Big Buddha + Promthep Cape sunset",
        "Phuket Fantasea cultural theme park + dinner show",
    ]},
    { n: "06", title: "Departure · Phuket → India", items: [
        "Leisurely breakfast",
        "Private transfer to HKT airport",
        "Return flight home",
    ]},
  ],
  gallery: [
    { name: "Phi Phi Island",   img: "https://images.pexels.com/photos/1007657/pexels-photo-1007657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Grand Palace",     img: "https://images.pexels.com/photos/1007657/pexels-photo-1007657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Patong Beach",     img: "https://images.pexels.com/photos/1320686/pexels-photo-1320686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Street Food",      img: "https://images.pexels.com/photos/1414651/pexels-photo-1414651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "The Agarwal Family", tag: "Delhi · Group of 4",    img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Phi Phi islands were unreal and Safari World kept the kids hooked. Hotels in both Bangkok and Phuket were spot-on 4-star." },
    { name: "Simran & Rohit",     tag: "Chandigarh · Honeymoon", img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Best value-for-money honeymoon. Phuket Fantasea was a magical last night. Vacations Pro handled visa-on-arrival paperwork perfectly." },
    { name: "Manish K.",          tag: "Mumbai · Family",       img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "3 days in Phuket was perfect. Phi Phi day cruise, Big Buddha sunset, Patong walking street — something for everyone." },
  ],
  faqs: [
    { q: "Is ₹42,000 the final price?",
      a: "Yes — ₹42,000 per person (twin share) includes return international flights + internal BKK-Phuket flight, 5 nights of 4-star hotels, daily breakfast, all listed tours (Safari World, Grand Palace, Phi Phi cruise, Phuket Fantasea), and airport transfers. Only Thai VOA fee (~₹3,500) and personal meals are extra." },
    { q: "Do Indians need a Thai visa?",
      a: "Thailand offers Visa on Arrival (VOA) for Indians — 30 days, ~1,900 THB (~₹3,500). We pre-fill the TM6 form and share an on-arrival guide. Faster options: e-Visa (~₹4,000, 7 days ahead)." },
    { q: "Why Bangkok + Phuket together?",
      a: "Bangkok gives temples + shopping + Safari World (great for families). Phuket gives beaches + island hopping + Fantasea. 2+3 split is the sweet spot for first-time visitors. We can also do Phuket-only or Krabi swap on request." },
    { q: "Is Thailand safe for Indian women / solo travellers?",
      a: "Thailand is one of the safest Southeast Asian countries for Indian families & solo travellers. Our partner hotels have 24×7 security + women-friendly booking processes." },
    { q: "Is there Indian / Jain food in Phuket?",
      a: "Yes — Phuket has 20+ Indian restaurants (Patong, Karon areas). We curate the 4-star hotel choice near these options. Jain pre-orders can be arranged 48 hours ahead." },
    { q: "When is the best time to visit Thailand?",
      a: "November to February is peak (25-32°C, no monsoon). Our base ₹42,000 price is for this peak window. May-October offers 15-20% savings but some beach days may be rainy." },
  ],
  finalCta: { badge: "Only 20 seats left for Dec", headline: "Your Thailand escape starts at ₹42,000." },
  departureCity: "Delhi / Mumbai / Bengaluru / Chennai / Kolkata",
  arrivalCity: "Bangkok (BKK) + Phuket (HKT), Thailand",
  waSave: "₹10,000",
};

// ─────────────────────────────────────────────────────────────────
//  KASHMIR · Paradise on Earth
// ─────────────────────────────────────────────────────────────────
export const KASHMIR = {
  slug: "kashmir",
  price: 24000,
  currency: "INR",
  title: "Kashmir Paradise Escape",
  priceLabel: "From ₹24,000 per person.",
  duration: "4N / 5D",
  durationLong: "4 Nights · 5 Days",
  seoTitle: "Kashmir Tour Package ₹24,000 | Srinagar Gulmarg Pahalgam 4N/5D | Vacations Pro",
  seoDesc:
    "All-inclusive Kashmir package from ₹24,000 per person — Srinagar houseboat, Gulmarg Gondola, Pahalgam valley. Private AC car, 4★ hotels, daily breakfast. Trusted since 2004.",
  ogTitle: "Kashmir Paradise Package ₹24,000 | 4N/5D | Vacations Pro",
  ogDesc: "Srinagar + Gulmarg + Pahalgam with Dal Lake houseboat night. From ₹24,000 pp.",
  eyebrow: "Spring 2026 · Tulip Season",
  heroImg: "https://images.pexels.com/photos/3889929/pexels-photo-3889929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Kashmir Dal Lake Srinagar houseboat sunrise — Vacations Pro tour",
  subline:
    "4 Nights · 5 Days across Srinagar, Gulmarg and Pahalgam — flights included, private AC Innova/Ertiga, Dal Lake deluxe houseboat, Gulmarg Gondola Phase-1, Pahalgam valley pony ride. Kashmir specialists from Punjab since 2004.",
  statStrip: [
    ["4N/5D", "Duration"],
    ["Houseboat", "1 Night"],
    ["4★", "Hotels"],
    ["Private", "Innova / Ertiga"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",       body: "Delhi → Srinagar (SXR)" },
    { icon: "Hotel",      title: "4N Stay",              body: "1N Houseboat + 3N 4★ hotels" },
    { icon: "Bus",        title: "Private AC Car",       body: "Innova / Ertiga + driver" },
    { icon: "Coffee",     title: "Daily Breakfast",      body: "At all properties" },
    { icon: "Compass",    title: "Gulmarg Gondola",      body: "Phase-1 ticket · shikara ride" },
    { icon: "FileCheck2", title: "All Transfers",        body: "Airport + inter-city" },
  ],
  whyUs: [
    { title: "Altitude-Safe", body: "Paced itinerary · Srinagar (5,200 ft) before Gulmarg (8,694 ft) to avoid AMS." },
    { title: "Handpicked Houseboats", body: "We've personally stayed at every partner houseboat — no random listings." },
    { title: "24×7 On-Trip Support", body: "Srinagar-based driver + Hindi/English/Urdu ground team on WhatsApp." },
    { title: "500+ Punjab Families", body: "Ludhiana/Amritsar/Jalandhar travellers since 2004 — best local rates." },
  ],
  days: [
    { n: "01", title: "Arrival Srinagar · Dal Lake Shikara", items: [
        "Morning flight Delhi → Srinagar (SXR)",
        "Hotel check-in · lunch at Chashme Shahi gardens",
        "Evening shikara ride on Dal Lake · stay at 4★ property",
    ]},
    { n: "02", title: "Srinagar → Gulmarg Day Trip", items: [
        "Scenic 2-hour drive to Gulmarg meadows",
        "Gulmarg Gondola Phase-1 · snow point",
        "Return to Srinagar · overnight on Dal Lake houseboat",
    ]},
    { n: "03", title: "Srinagar → Pahalgam Valley", items: [
        "Saffron fields + Awantipora ruins enroute",
        "Check-in at Pahalgam resort · lunch",
        "Evening walk by Lidder river · shopping",
    ]},
    { n: "04", title: "Pahalgam Sightseeing · Aru Valley", items: [
        "Aru Valley + Betaab Valley + Chandanwari",
        "Pony ride (included) · picnic lunch",
        "Overnight in Pahalgam",
    ]},
    { n: "05", title: "Pahalgam → Srinagar → Departure", items: [
        "Breakfast + drive to Srinagar airport",
        "Mughal Gardens (Nishat / Shalimar) if flight allows",
        "Return flight home",
    ]},
  ],
  gallery: [
    { name: "Dal Lake Shikara",  img: "https://images.pexels.com/photos/3673905/pexels-photo-3673905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Gulmarg Gondola",   img: "https://images.pexels.com/photos/2474689/pexels-photo-2474689.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Pahalgam Valley",   img: "https://images.pexels.com/photos/5207262/pexels-photo-5207262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Mughal Gardens",    img: "https://images.pexels.com/photos/3889929/pexels-photo-3889929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Gurpreet Singh", tag: "Amritsar · Family of 5", img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Houseboat night was magical — fresh wazwan dinner on the deck. Driver was like family by day 5. Best Kashmir trip after 3 earlier attempts with other agents." },
    { name: "Neha Malhotra",  tag: "Delhi · Honeymoon",       img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Tulip garden + Gulmarg snow + shikara sunset = the honeymoon of our dreams. ₹24K felt impossibly cheap for the experience." },
    { name: "Dr. Anjali R.",  tag: "Chandigarh · Couple",     img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Pahalgam valley walk, Betaab valley picnic, everything exactly as promised. Paperwork-free and stress-free." },
  ],
  faqs: [
    { q: "Is ₹24,000 the final price? Any hidden charges?",
      a: "Yes — ₹24,000 per person (twin share) covers return Delhi-Srinagar flights, 1 night houseboat + 3 nights of 4-star hotels, private Innova with driver for all days, daily breakfast, Gulmarg Gondola Phase-1 + Pahalgam pony ride tickets. Only personal meals / extra pony points / Phase-2 Gondola are extras." },
    { q: "When is the best time to visit Kashmir?",
      a: "Apr-May is tulip season (gorgeous, moderate crowds). Jun-Aug is peak summer. Oct-Nov is golden autumn (chinar trees). Dec-Feb is snow season (Gulmarg skiing). We run year-round with seasonal itinerary tweaks." },
    { q: "Is Kashmir safe for Indian tourists right now?",
      a: "Yes — we run 500+ trips a year without incident. Sightseeing areas (Srinagar, Gulmarg, Pahalgam) are fully secure and bustling with tourists. Our local team monitors conditions daily." },
    { q: "Do you provide pick-up from Ludhiana / Amritsar?",
      a: "Flight routing from Delhi is included. For Ludhiana/Amritsar, we book Amritsar→Delhi feeder flights or arrange AC Tempo Traveller pickup (+₹4,500 one-way)." },
    { q: "What's the houseboat like — is it safe/clean?",
      a: "We only partner with deluxe-class houseboats (A/B category, walnut-wood interiors, attached bathrooms, 24×7 security). Personally inspected every monsoon by our team." },
    { q: "What clothing should I pack?",
      a: "Apr-May: light layers + one warm jacket. Jun-Aug: cotton + light jacket for Gulmarg. Oct-Feb: heavy woollens, thermal layer, waterproof shoes. We share a full packing list 3 days before departure." },
  ],
  finalCta: { badge: "Only 14 seats left for May tulip season", headline: "Your Kashmir paradise starts at ₹24,000." },
  departureCity: "Ludhiana / Delhi / Amritsar / Mumbai",
  arrivalCity: "Srinagar (SXR), Kashmir",
  waSave: "₹6,000",
};

// ─────────────────────────────────────────────────────────────────
//  VIETNAM · Timeless Charm
// ─────────────────────────────────────────────────────────────────
export const VIETNAM = {
  slug: "vietnam",
  price: 52000,
  currency: "INR",
  title: "Vietnam Hanoi & Ha Long",
  priceLabel: "From ₹52,000 per person.",
  duration: "6N / 7D",
  durationLong: "6 Nights · 7 Days",
  seoTitle: "Vietnam Tour Package ₹52,000 from India | Hanoi + Ha Long + Hoi An | Vacations Pro",
  seoDesc:
    "All-inclusive Vietnam tour from ₹52,000 per person — Hanoi, Ha Long Bay overnight cruise, Hoi An lantern town. Return flights, 4★ hotels, e-visa assistance. Trusted since 2004.",
  ogTitle: "Vietnam Heritage Package ₹52,000 from India | Vacations Pro",
  ogDesc: "6N/7D Vietnam: Hanoi + Ha Long overnight junk boat + Hoi An lanterns. From ₹52,000 pp.",
  eyebrow: "Winter 2026 · E-Visa Easy",
  heroImg: "https://images.pexels.com/photos/2835436/pexels-photo-2835436.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Ha Long Bay junk boat limestone karsts — Vacations Pro Vietnam tour",
  subline:
    "6 Nights · 7 Days across Hanoi, Ha Long Bay and Hoi An — return flights, 4-star hotels, overnight luxury junk cruise, 500-year-old lantern town, street-food trails. Crafted by Vacations Pro since 2004.",
  statStrip: [
    ["6N/7D", "Duration"],
    ["Overnight", "Ha Long Cruise"],
    ["4★", "Hotels"],
    ["E-Visa", "Assistance"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",     body: "Delhi / Mumbai → Hanoi (HAN)" },
    { icon: "Hotel",      title: "6N Stay",            body: "4★ + 1N luxury junk boat" },
    { icon: "Bus",        title: "Airport Transfers",  body: "Private AC car" },
    { icon: "Coffee",     title: "Daily Breakfast",    body: "+ all cruise meals" },
    { icon: "Compass",    title: "Guided Tours",       body: "Hanoi · Ha Long · Hoi An" },
    { icon: "FileCheck2", title: "E-Visa Support",     body: "USD 25 · 30-day single" },
  ],
  whyUs: [
    { title: "Lowest Price Promise", body: "See a lower same-itinerary quote? We'll beat it by ₹1,500." },
    { title: "Luxury Junk Partners", body: "Only 4★+ Indochina Junks or Paradise Cruises — no bargain-bin vessels." },
    { title: "24×7 On-Trip Support", body: "Hanoi + Hoi An ground teams on WhatsApp — Hindi/English." },
    { title: "Indian Meal Options",  body: "Veg-friendly hotels curated + Indian restaurant map for Hanoi." },
  ],
  days: [
    { n: "01", title: "Arrival Hanoi · Old Quarter Walk", items: [
        "Arrive HAN · airport pick-up + hotel check-in",
        "Evening Hoan Kiem Lake + water puppet show",
        "Street-food tour Old Quarter (pho + bun cha)",
    ]},
    { n: "02", title: "Hanoi City Tour · Train Street", items: [
        "Ho Chi Minh Mausoleum + One-Pillar Pagoda",
        "Temple of Literature + Train Street coffee",
        "Afternoon at leisure + egg-coffee café",
    ]},
    { n: "03", title: "Hanoi → Ha Long Bay Cruise", items: [
        "Morning 2-hour drive to Ha Long",
        "Board luxury junk + welcome lunch onboard",
        "Sunset kayaking + seafood dinner on deck",
    ]},
    { n: "04", title: "Ha Long Bay → Fly to Hoi An", items: [
        "Tai Chi at sunrise + cave exploration",
        "Brunch onboard + return to Hanoi",
        "Evening flight Hanoi → Danang · transfer Hoi An",
    ]},
    { n: "05", title: "Hoi An Lantern Town", items: [
        "Full-day Hoi An Ancient Town walk",
        "Tailor fitting (custom suit / ao dai)",
        "Evening boat ride + 1,000-lantern market",
    ]},
    { n: "06", title: "My Son Ruins + Free Day", items: [
        "My Son Sanctuary (UNESCO) morning tour",
        "Afternoon at An Bang beach · optional spa",
        "Farewell Vietnamese dinner + cooking class",
    ]},
    { n: "07", title: "Departure · Danang → India", items: [
        "Breakfast + private transfer to DAD",
        "Return flight via Hanoi or Bangkok",
        "Home with memories",
    ]},
  ],
  gallery: [
    { name: "Ha Long Bay",    img: "https://images.pexels.com/photos/2835436/pexels-photo-2835436.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Hoi An Lanterns",img: "https://images.pexels.com/photos/1007657/pexels-photo-1007657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Hanoi Old Quarter",img: "https://images.pexels.com/photos/1414651/pexels-photo-1414651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Vietnamese Coffee",img: "https://images.pexels.com/photos/414645/pexels-photo-414645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Divya Khanna",   tag: "Mumbai · Couple",     img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "The overnight junk boat in Ha Long was dreamy. Hoi An at night with 1,000 lanterns was the best photo we took all year." },
    { name: "The Shah Family",tag: "Ahmedabad · Family",  img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Kids loved Train Street and the cooking class in Hoi An. Vacations Pro handled e-visa + domestic flights seamlessly." },
    { name: "Rahul V.",       tag: "Bengaluru · Solo",    img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Foodie trip of a lifetime. Pho, bun cha, egg coffee, banh mi — the curated food walks were unbeatable." },
  ],
  faqs: [
    { q: "Is ₹52,000 the final price?",
      a: "Yes — ₹52,000 per person (twin share) includes return international + internal Hanoi-Danang flights, 5 hotel nights + 1 luxury junk-boat night, daily breakfast + all cruise meals, Hanoi/Hoi An guided tours and airport transfers. Only e-visa fee (~₹2,200) and personal meals are extra." },
    { q: "Do Indians need a visa for Vietnam?",
      a: "Yes — Vietnam e-Visa (single entry, 30 days, ~USD 25). We file it for you in 5-7 working days. 100% approval rate for clean Indian passports." },
    { q: "Is the Ha Long cruise safe and comfortable?",
      a: "We partner with 4★+ Indochina Sails / Paradise / Orchid cruises — licensed, inspected, private cabins with en-suite baths. Full safety briefing, life jackets, onboard doctor on call." },
    { q: "When is the best time to visit Vietnam?",
      a: "Nov-Apr is best for most of Vietnam (dry, cool). Avoid Jun-Sep in central Vietnam (typhoon risk). Our base price covers the Nov-Apr peak window." },
    { q: "Is there Indian / Jain food in Vietnam?",
      a: "Yes — Hanoi and Hoi An have 15+ Indian restaurants. Our partner hotels serve Indian breakfast options. Jain pre-orders can be arranged 48 hours ahead in Hanoi." },
    { q: "Can I customise — skip Hoi An or add Ho Chi Minh City?",
      a: "Absolutely. Popular swaps: add Ho Chi Minh + Mekong Delta (+2 nights, +₹9,500), extend Ha Long to 2-night cruise (+₹6,000), skip Hoi An for Sapa trekking (+₹4,000). Tell our consultant on the call." },
  ],
  finalCta: { badge: "Only 15 seats left for Dec", headline: "Your Vietnam escape starts at ₹52,000." },
  departureCity: "Delhi / Mumbai / Bengaluru / Kolkata",
  arrivalCity: "Hanoi (HAN) + Danang (DAD), Vietnam",
  waSave: "₹10,000",
};

// ─────────────────────────────────────────────────────────────────
//  SINGAPORE · Family Marina & Sentosa
// ─────────────────────────────────────────────────────────────────
export const SINGAPORE_PKG = {
  slug: "singapore",
  price: 58000,
  currency: "INR",
  title: "Singapore Marina & Sentosa",
  priceLabel: "From ₹58,000 per person.",
  duration: "4N / 5D",
  durationLong: "4 Nights · 5 Days",
  seoTitle: "Singapore Family Package ₹58,000 from India | Universal Studios + Marina Bay | Vacations Pro",
  seoDesc:
    "All-inclusive Singapore family tour from ₹58,000 per person — return flights, 4★ hotels, Universal Studios, Marina Bay Gardens, Sentosa day. Singapore family specialists since 2004.",
  ogTitle: "Singapore Family Package ₹58,000 from India | Vacations Pro",
  ogDesc: "4N/5D Singapore with Universal Studios, Gardens by the Bay, Sentosa. From ₹58,000 pp.",
  eyebrow: "Winter 2026 · Family Favourite",
  heroImg: "https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Singapore Marina Bay Sands skyline — Vacations Pro family tour",
  subline:
    "4 Nights · 5 Days in Singapore — return flights, 4-star hotel near the Metro, Universal Studios + Sentosa + Gardens by the Bay + hawker food trail. The safest, family-friendliest Asian gateway for first-time international travellers.",
  statStrip: [
    ["4N/5D", "Duration"],
    ["Universal", "Studios Day"],
    ["4★", "Hotels"],
    ["Metro", "Walk-5 min"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",          body: "Delhi / Mumbai / BLR → SIN" },
    { icon: "Hotel",      title: "4N Hotel Stay",           body: "4★ near MRT" },
    { icon: "Bus",        title: "Airport Transfers",       body: "Private AC + SIM card" },
    { icon: "Coffee",     title: "Daily Breakfast",         body: "At the hotel" },
    { icon: "Compass",    title: "City + Sentosa + USS",    body: "All 3 day tours" },
    { icon: "FileCheck2", title: "E-Visa Assistance",       body: "SAVE approval in 3 days" },
  ],
  whyUs: [
    { title: "STB Licensed Partner", body: "Singapore Tourism Board registered — all tickets + attraction passes." },
    { title: "4★ Near MRT", body: "Walking distance to Metro = massive savings on airport/taxi rides over 4 days." },
    { title: "Free Tourist SIM", body: "1 SIM per family on arrival — Gmaps + WhatsApp handle everything." },
    { title: "25+ Family Trips/Month", body: "We run 25+ Singapore family groups every month — we know every shortcut." },
  ],
  days: [
    { n: "01", title: "Arrival · Marina Bay Night Tour", items: [
        "Arrive SIN + MRT-easy hotel check-in",
        "Evening Merlion Park + Marina Bay walk",
        "Gardens by the Bay Supertree light show",
    ]},
    { n: "02", title: "Sentosa Island Full Day", items: [
        "Singapore Cable Car to Sentosa",
        "SEA Aquarium + Madame Tussauds",
        "Wings of Time sunset laser show",
    ]},
    { n: "03", title: "Universal Studios Full Day", items: [
        "USS open-to-close — Transformers + Battlestar",
        "Hawker dinner at Newton Food Centre",
        "Optional night Zoo upgrade available",
    ]},
    { n: "04", title: "City Tour + Shopping", items: [
        "Little India + Chinatown + Arab Street",
        "Mustafa Centre shopping + spice souk",
        "Afternoon at Gardens by the Bay domes",
    ]},
    { n: "05", title: "Departure · SIN → India", items: [
        "Breakfast + Jewel Changi explore",
        "Rain Vortex waterfall + Canopy Park",
        "Return flight home",
    ]},
  ],
  gallery: [
    { name: "Marina Bay",    img: "https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Supertrees",    img: "https://images.pexels.com/photos/2070018/pexels-photo-2070018.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Sentosa Beach", img: "https://images.pexels.com/photos/777059/pexels-photo-777059.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Hawker Food",   img: "https://images.pexels.com/photos/1630588/pexels-photo-1630588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "The Kapoor Family", tag: "Delhi · Group of 5",   img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Universal Studios was a dream for the kids. Our 4-star hotel was 5 min from the MRT — saved us a fortune on cabs." },
    { name: "Priya & Vikram",    tag: "Mumbai · Honeymoon",    img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Supertree light show + Jewel Changi at the end = the best evenings of the trip. ₹58K felt like fantastic value." },
    { name: "Arjun M.",          tag: "Bengaluru · Family",    img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "The free SIM + walking-distance MRT hotel were game-changers. Vacations Pro really knows Singapore." },
  ],
  faqs: [
    { q: "Is ₹58,000 the final price?",
      a: "Yes — ₹58,000 per person (twin share) includes return flights, 4 nights of 4-star hotel near MRT, daily breakfast, all 3 day tours (Sentosa, USS, City), airport transfers + free tourist SIM. Only e-visa (~₹1,800) and personal meals/attractions are extra." },
    { q: "Do Indians need a Singapore visa?",
      a: "Yes — e-Visa (SAVE) required, ~₹1,800, 3-5 day processing. We handle the entire application. Approval rate 99% for clean passports + return tickets." },
    { q: "Is Universal Studios suitable for kids of all ages?",
      a: "USS is best for kids 6+ (height restrictions on coaster rides). For 3-6 age, Sentosa's SEA Aquarium + Madame Tussauds + beach day is often a better value add-on." },
    { q: "Which Indian cities have direct flights?",
      a: "Direct from Delhi, Mumbai, Bengaluru, Chennai, Hyderabad, Kolkata. Amritsar/Ludhiana via Delhi. All sub-5-hour direct flights." },
    { q: "Is there Indian / Jain food in Singapore?",
      a: "Abundantly — Little India has 50+ Indian restaurants, Mustafa Centre is 24-hour vegetarian-friendly. We book hotels near Indian food clusters or with Indian in-house dining." },
    { q: "Can I add Malaysia or Bali?",
      a: "Yes — Singapore + Kuala Lumpur (+3 nights, +₹12K), Singapore + Bali (+4 nights, +₹22K), Singapore + Phuket (+3 nights, +₹16K). Popular combos with domestic-flight routing." },
  ],
  finalCta: { badge: "Only 18 seats left for Dec school break", headline: "Your Singapore family trip starts at ₹58,000." },
  departureCity: "Delhi / Mumbai / Bengaluru / Chennai",
  arrivalCity: "Singapore (SIN)",
  waSave: "₹12,000",
};

// ─────────────────────────────────────────────────────────────────
//  SWITZERLAND · Alps & Glacier Express
// ─────────────────────────────────────────────────────────────────
export const SWITZERLAND = {
  slug: "switzerland",
  price: 185000,
  currency: "INR",
  title: "Swiss Alps & Glacier Express",
  priceLabel: "From ₹1,85,000 per person.",
  duration: "6N / 7D",
  durationLong: "6 Nights · 7 Days",
  seoTitle: "Switzerland Luxury Tour ₹1,85,000 from India | Jungfrau + Zermatt + Glacier Express | Vacations Pro",
  seoDesc:
    "Luxury Switzerland tour from ₹1,85,000 per person — Zurich, Interlaken, Jungfraujoch, Zermatt, Glacier Express, Lake Lucerne. Swiss Rail Pass included. Swiss specialists since 2004.",
  ogTitle: "Switzerland Luxury Tour ₹1,85,000 from India | Vacations Pro",
  ogDesc: "6N/7D Swiss Alps with Jungfrau Top of Europe, Glacier Express, Zermatt. From ₹1,85,000 pp.",
  eyebrow: "Summer 2026 · Swiss Rail Pass",
  heroImg: "https://images.pexels.com/photos/1761279/pexels-photo-1761279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Swiss Alps Matterhorn Zermatt — Vacations Pro luxury Swiss tour",
  subline:
    "6 Nights · 7 Days across Zurich, Interlaken, Zermatt and Lucerne — return flights, 4★+ hotels, Swiss Rail Pass, Jungfraujoch Top of Europe, Glacier Express panorama train, Matterhorn viewing deck. Swiss Rail booking agents since 2004.",
  statStrip: [
    ["6N/7D", "Duration"],
    ["Swiss Rail", "Pass Included"],
    ["4★+", "Hotels"],
    ["Jungfrau", "Top of Europe"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",      body: "Delhi / Mumbai → Zurich (ZRH)" },
    { icon: "Hotel",      title: "6N Hotel Stay",       body: "4★+ Interlaken / Zermatt / Lucerne" },
    { icon: "Bus",        title: "Swiss Rail Pass",     body: "6-day Consecutive · All trains" },
    { icon: "Coffee",     title: "Daily Breakfast",     body: "At every hotel" },
    { icon: "Compass",    title: "Jungfrau + Glacier",  body: "Top of Europe + panorama train" },
    { icon: "FileCheck2", title: "Schengen Visa Help",  body: "VFS filing + cover letters" },
  ],
  whyUs: [
    { title: "Swiss Travel System Agent", body: "Authorised Swiss Rail booking partner — official pass, not third-party." },
    { title: "Premium Hotels Only", body: "4★+ Interlaken (Victoria Jungfrau zone), Zermatt (with Matterhorn view where possible)." },
    { title: "24×7 On-Trip Support", body: "Hindi + English WhatsApp line + Zurich ground contact." },
    { title: "Indian-Friendly Itinerary", body: "Breakfast-ready hotels + Indian dinner pointers for every city." },
  ],
  days: [
    { n: "01", title: "Arrival Zurich · Lake Walk", items: [
        "Arrive ZRH + train to Zurich city (included)",
        "Hotel check-in · evening Bahnhofstrasse walk",
        "Lake Zurich boat ride at sunset",
    ]},
    { n: "02", title: "Zurich → Interlaken via Lucerne", items: [
        "Morning Lucerne old town + Chapel Bridge",
        "Mt. Pilatus golden round trip (optional)",
        "Scenic train Lucerne → Interlaken (2 hrs)",
    ]},
    { n: "03", title: "Jungfraujoch · Top of Europe", items: [
        "Cogwheel train via Kleine Scheidegg to 3,454 m",
        "Ice Palace, Sphinx Observatory, Snow Fun",
        "Return to Interlaken · free evening",
    ]},
    { n: "04", title: "Interlaken → Zermatt", items: [
        "Scenic Bernese Oberland railway",
        "Arrive car-free Zermatt + Matterhorn view",
        "Walk to Sunnegga paradise viewpoint",
    ]},
    { n: "05", title: "Matterhorn Glacier Paradise", items: [
        "Cable car to 3,883 m — highest in Europe",
        "Glacier Palace + Cinema Lounge",
        "Afternoon Gornergrat railway option",
    ]},
    { n: "06", title: "Glacier Express · Zermatt → Lucerne", items: [
        "World's slowest express — 8 hrs panorama",
        "Onboard lunch (pre-booked)",
        "Arrive Lucerne · farewell dinner",
    ]},
    { n: "07", title: "Departure · Zurich → India", items: [
        "Train Lucerne → Zurich airport",
        "Duty-free shopping time",
        "Return flight home",
    ]},
  ],
  gallery: [
    { name: "Matterhorn",       img: "https://images.pexels.com/photos/1761279/pexels-photo-1761279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Jungfraujoch",     img: "https://images.pexels.com/photos/358502/pexels-photo-358502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Glacier Express",  img: "https://images.pexels.com/photos/210243/pexels-photo-210243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Lake Lucerne",     img: "https://images.pexels.com/photos/460621/pexels-photo-460621.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Dr. Sandeep K.",  tag: "Delhi · Family",     img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Jungfraujoch in July with snow on the ground — our kids couldn't believe it. Swiss Rail Pass made getting around effortless." },
    { name: "Meera & Rohan",   tag: "Mumbai · Honeymoon", img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Zermatt Matterhorn sunrise and the Glacier Express were cinematic. Vacations Pro handled Schengen paperwork like pros." },
    { name: "The Malhotras",   tag: "Chandigarh · Group", img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Six of us, six cities, zero issues. Hotels were 4★+ throughout. Indian dinner pointers saved us every night." },
  ],
  faqs: [
    { q: "Is ₹1,85,000 the final price?",
      a: "Yes — ₹1,85,000 per person (twin share) includes return flights, 6 nights of 4★+ hotels, 6-day Swiss Rail Pass (consecutive), daily breakfast, Jungfraujoch + Matterhorn Glacier Paradise + Glacier Express tickets. Only Schengen visa fee (~₹8,500), personal lunches/dinners and optional add-ons are extra." },
    { q: "What about the Schengen visa?",
      a: "We file your Schengen visa application via VFS — cover letters, bank docs, tour vouchers, insurance. 15-20 day processing. 97% approval rate for our Indian clients with complete paperwork." },
    { q: "Is the Swiss Rail Pass worth it?",
      a: "Yes — Swiss point-to-point rail fares add up to ₹40-50K/person. The included pass covers ALL our scenic trains + local transit + 50% off mountain excursions. Hugely better value." },
    { q: "When is the best time to go?",
      a: "Jun-Sep is peak summer (lush, long days, all passes open). Dec-Mar is ski season (Zermatt, Jungfrau open). We run year-round with seasonal swaps." },
    { q: "Is there Indian food in Switzerland?",
      a: "Yes — Zurich, Interlaken and Lucerne all have Indian restaurants (₹1,500-2,500/meal). We share a curated list by city. Breakfast at our partner hotels includes Indian options." },
    { q: "Can I add Paris or Italy?",
      a: "Common extensions: +Paris (+3 nights, +₹65K), +Rome-Venice (+4 nights, +₹75K), +Amsterdam (+2 nights, +₹45K). Multi-country Schengen visa covers all." },
  ],
  finalCta: { badge: "Only 6 seats left for peak summer", headline: "Your Swiss Alps escape starts at ₹1,85,000." },
  departureCity: "Delhi / Mumbai / Bengaluru",
  arrivalCity: "Zurich (ZRH), Switzerland",
  waSave: "₹35,000",
};

// ─────────────────────────────────────────────────────────────────
//  JAPAN · Tokyo, Kyoto & Sakura
// ─────────────────────────────────────────────────────────────────
export const JAPAN_PKG = {
  slug: "japan",
  price: 145000,
  currency: "INR",
  title: "Japan Tokyo, Kyoto & Sakura",
  priceLabel: "From ₹1,45,000 per person.",
  duration: "7N / 8D",
  durationLong: "7 Nights · 8 Days",
  seoTitle: "Japan Cherry Blossom Tour ₹1,45,000 from India | Tokyo + Kyoto + Mt Fuji | Vacations Pro",
  seoDesc:
    "All-inclusive Japan tour from ₹1,45,000 per person — Tokyo, Kyoto cherry blossoms, Mt Fuji, JR Rail Pass, ryokan onsen night. Shinkansen-included Japan specialists since 2004.",
  ogTitle: "Japan Cherry Blossom Tour ₹1,45,000 from India | Vacations Pro",
  ogDesc: "7N/8D Japan: Tokyo, Kyoto, Mt Fuji, sakura season + onsen ryokan. From ₹1,45,000 pp.",
  eyebrow: "Sakura 2026 · Limited Seats",
  heroImg: "https://images.pexels.com/photos/2506923/pexels-photo-2506923.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
  heroAlt: "Japan Kyoto cherry blossom pagoda — Vacations Pro sakura tour",
  subline:
    "7 Nights · 8 Days across Tokyo, Kyoto, Hakone and Mt Fuji — return flights, 4★ hotels + 1 night ryokan with onsen, 7-day JR Rail Pass, Shinkansen bullet train, cherry-blossom peak timing (early April).",
  statStrip: [
    ["7N/8D", "Duration"],
    ["JR Pass", "7-Day Included"],
    ["Ryokan", "1 Night Onsen"],
    ["Sakura", "Peak Timing"],
  ],
  inclusions: [
    { icon: "Plane",      title: "Return Flights",     body: "Delhi / Mumbai → Tokyo (NRT)" },
    { icon: "Hotel",      title: "7N Stay",            body: "6N 4★ + 1N ryokan onsen" },
    { icon: "Bus",        title: "JR Rail Pass",       body: "7-day all-Shinkansen" },
    { icon: "Coffee",     title: "Daily Breakfast",    body: "+ 1 kaiseki ryokan dinner" },
    { icon: "Compass",    title: "Guided Tours",       body: "Tokyo · Kyoto · Hakone" },
    { icon: "FileCheck2", title: "Visa Assistance",    body: "15-day VFS processing" },
  ],
  whyUs: [
    { title: "Sakura Timing Expertise", body: "We book 12 months ahead to catch peak bloom (~Apr 5-10 Kyoto)." },
    { title: "Ryokan Handpicked", body: "Partner-inspected hot-spring ryokan in Hakone with Mt Fuji view." },
    { title: "Indian-Friendly Guides", body: "English-speaking guides briefed on Indian dietary + pace preferences." },
    { title: "JR Pass Authorised", body: "We are JR Rail Pass reselling agents — official voucher, not third-party." },
  ],
  days: [
    { n: "01", title: "Arrival Tokyo · Shibuya Crossing", items: [
        "Arrive NRT + Narita Express to Tokyo",
        "Hotel check-in · evening Shibuya crossing",
        "Ramen dinner at Ichiran or Ippudo",
    ]},
    { n: "02", title: "Tokyo City Tour", items: [
        "Meiji Shrine + Harajuku street style",
        "Senso-ji temple Asakusa + Nakamise souvenir lane",
        "Tokyo Tower or Skytree sunset",
    ]},
    { n: "03", title: "Tokyo → Hakone · Ryokan Night", items: [
        "Shinkansen to Odawara + Hakone loop",
        "Lake Ashi pirate ship + Owakudani valley",
        "Check-in ryokan + onsen bath + kaiseki dinner",
    ]},
    { n: "04", title: "Hakone → Kyoto via Mt Fuji", items: [
        "Morning Mt Fuji photo stops (weather-dependent)",
        "Shinkansen to Kyoto (2.5 hrs)",
        "Evening Gion geisha district walk",
    ]},
    { n: "05", title: "Kyoto · Temples & Bamboo Grove", items: [
        "Fushimi Inari 1,000 torii gates",
        "Arashiyama bamboo grove + Togetsukyo bridge",
        "Kinkaku-ji Golden Pavilion",
    ]},
    { n: "06", title: "Kyoto · Cherry Blossom Experience", items: [
        "Philosopher's Path sakura-lined walk",
        "Maruyama Park hanami picnic",
        "Traditional tea ceremony + kimono rental",
    ]},
    { n: "07", title: "Kyoto → Tokyo · Shopping Day", items: [
        "Morning Shinkansen back to Tokyo",
        "Ginza + Akihabara electronics/anime",
        "Farewell sushi dinner Tsukiji-style",
    ]},
    { n: "08", title: "Departure · Tokyo → India", items: [
        "Hotel breakfast + Narita Express",
        "NRT departure",
        "Home with unforgettable memories",
    ]},
  ],
  gallery: [
    { name: "Kyoto Sakura",    img: "https://images.pexels.com/photos/2506923/pexels-photo-2506923.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700", aspect: "tall" },
    { name: "Fushimi Inari",   img: "https://images.pexels.com/photos/161172/cherry-blossoms-sakura-cherry-trees-flowers-161172.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1400" },
    { name: "Tokyo Shibuya",   img: "https://images.pexels.com/photos/2506947/pexels-photo-2506947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
    { name: "Mt Fuji Hakone",  img: "https://images.pexels.com/photos/46253/mt-fuji-sea-of-clouds-sunrise-46253.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  ],
  reviews: [
    { name: "Nisha & Karan",  tag: "Mumbai · Honeymoon",   img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "We caught Kyoto's sakura at peak bloom — a once-in-a-lifetime moment. Ryokan onsen with Mt Fuji view was magical." },
    { name: "The Sharma Family",tag: "Delhi · Group of 4",  img: "https://images.pexels.com/photos/18702939/pexels-photo-18702939.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "JR Rail Pass made everything smooth. Kids loved Akihabara, parents loved Kyoto temples. Best family trip in 10 years." },
    { name: "Ravi B.",        tag: "Bengaluru · Couple",    img: "https://images.pexels.com/photos/6136716/pexels-photo-6136716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200", quote: "Tokyo crossing + Kyoto bamboo + Fushimi Inari gates + kaiseki dinner = dream itinerary. Vacations Pro nailed the sakura timing." },
  ],
  faqs: [
    { q: "Is ₹1,45,000 the final price?",
      a: "Yes — ₹1,45,000 per person (twin share) includes return flights, 6 nights 4★ hotels + 1 night ryokan onsen, 7-day JR Rail Pass (all Shinkansen), daily breakfast + 1 kaiseki dinner, guided tours in Tokyo/Kyoto/Hakone. Only Japan visa fee (~₹450), personal meals and optional kimono rentals are extra." },
    { q: "When is sakura / cherry blossom peak?",
      a: "Kyoto/Osaka: Mar 28 - Apr 7. Tokyo: Mar 25 - Apr 3. Our Apr 2-9 departures typically land 3-5 peak-bloom days. Book 6+ months ahead for sakura dates — hotels fill up." },
    { q: "Do Indians need a Japan visa?",
      a: "Yes — Japan tourist e-visa (~₹450, 5-7 working days via VFS). We file the full application with cover letter + itinerary + hotel vouchers. 95% approval rate for clean passports." },
    { q: "Is there vegetarian / Jain food in Japan?",
      a: "Vegetarian: moderate (tofu, tempura, udon widely available). Jain: challenging but possible — Kyoto has 3-4 certified Jain-compatible restaurants. We pre-arrange meals + carry packed breakfasts for temple-visit days." },
    { q: "Will I see Mt Fuji?",
      a: "Weather-dependent (~60-70% visibility in April). Our itinerary includes 2 Mt Fuji photo-op stops (Lake Ashi + Hakone ropeway) to maximise chances." },
    { q: "Can I add Osaka or Hiroshima?",
      a: "Yes — JR Rail Pass already covers both. Add 1 night Osaka street food (+₹12K) or Hiroshima Peace Park (+₹15K). Tell our consultant on the call." },
  ],
  finalCta: { badge: "Only 8 seats left for sakura peak", headline: "Your Japan sakura escape starts at ₹1,45,000." },
  departureCity: "Delhi / Mumbai / Bengaluru",
  arrivalCity: "Tokyo Narita (NRT), Japan",
  waSave: "₹25,000",
};

// Export all for easy iteration (LP index page, sitemap, etc.)
export const PACKAGE_CONFIGS = {
  bali: BALI,
  maldives: MALDIVES,
  "leh-ladakh": LEH,
  "sri-lanka": SRI_LANKA,
  dubai: DUBAI,
  thailand: THAILAND,
  kashmir: KASHMIR,
  vietnam: VIETNAM,
  singapore: SINGAPORE_PKG,
  switzerland: SWITZERLAND,
  japan: JAPAN_PKG,
};
